import PropTypes from "prop-types";

import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

const NextPageStatus = ({
  sentinelRef,
  isFetchingNextPage,
  isNextPageError,
  hasLoadedAll,
  onRetry,
}) => (
  <div
    ref={sentinelRef}
    className="tw:flex tw:min-h-6 tw:items-center tw:justify-center"
  >
    {isFetchingNextPage && <Spinner />}
    {isNextPageError && (
      <Button type="button" variant="ghost" size="xs" onClick={onRetry}>
        Could not load more tags. Retry
      </Button>
    )}
    {hasLoadedAll && (
      <span className="tw:text-xs tw:text-muted-foreground">
        No more tags to show.
      </span>
    )}
  </div>
);

NextPageStatus.propTypes = {
  sentinelRef: PropTypes.func.isRequired,
  isFetchingNextPage: PropTypes.bool,
  isNextPageError: PropTypes.bool,
  hasLoadedAll: PropTypes.bool,
  onRetry: PropTypes.func.isRequired,
};

export default NextPageStatus;
